import { useAfterLaunch } from '../../productRouting/releaseConfig';

// Single source of truth for the marketing footer links. Every page that renders
// MarketingFooter uses these lists so the footer is identical across the site.

// Before launch: today's footer.
const MARKETING_FOOTER_COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Routora Team', href: '/teams-intro' },
      { label: 'Personal Workspace', href: '/web-intro' },
      { label: 'Routora for Government', href: '/gov-intro' },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Privacy', href: '/privacy-policy' },
      { label: 'Delete account', href: '/delete-account' },
      { label: 'Terms', href: '/terms-of-service' },
    ],
  },
];

// After launch: Routora Pro leads, each legacy product keeps its own sign-in,
// and returning subscribers can find "Already subscribed?" from any page.
export const LAUNCH_FOOTER_COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Routora Pro', href: '/web-intro' },
      { label: 'Mobile app', href: '/app-install' },
      { label: 'Routora Team', href: '/teams-intro' },
      { label: 'Chrome extension', href: '/pricing-extension' },
      { label: 'Routora for Government', href: '/gov-intro' },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
  {
    title: 'Help',
    links: [
      { label: 'Already subscribed?', href: '/already-subscribed' },
      { label: 'Teams sign-in', href: '/teams/login' },
      { label: 'Extension sign-in', href: '/extension/login' },
      { label: 'Contact us', href: 'mailto:info@routora.com' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Product guide', href: '/llm-info.html' },
      { label: 'Privacy', href: '/privacy-policy' },
      { label: 'Delete account', href: '/delete-account' },
      { label: 'Terms', href: '/terms-of-service' },
    ],
  },
];

export function useMarketingFooterColumns() {
  return useAfterLaunch() ? LAUNCH_FOOTER_COLUMNS : MARKETING_FOOTER_COLUMNS;
}

export default MARKETING_FOOTER_COLUMNS;
